import { Component, OnInit } from '@angular/core';
import {NotificationComponent} from '../admin/notification/notification.component';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  modalRef!: MDBModalRef; 

  constructor(
    private modalService: MDBModalService,
  ) { }

  ngOnInit(): void {
  }

  LoadNotification(elementId: string) {
    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: '',
      containerClass: '',
      animated: true,
      // data: {
      //   selectedoffering: elementId,
      // }
    }
    this.modalRef = this.modalService.show(NotificationComponent, modalOptions)
  }


}
